module.exports = __webpack_public_path__ + "static/media/WellbeingLab.d34000ac.jpeg";